module.exports = __webpack_public_path__ + "img/9833c2d.jpg";